import get from 'lodash/get';
import { GetKyc } from 'shared/data/walletsKyc/v1';

import { FormDataFields, stepMeaningfulFieldsMap, WizardStep, wizardSteps } from '../constants';

const isValueFilled = (formData: NonNullable<GetKyc['response']['data']>, field: FormDataFields) => {
    const value = get(formData, field);

    if (Array.isArray(value)) {
        return value.length > 0;
    }

    if (typeof value === 'boolean') {
        return true;
    }

    return Boolean(value);
};

/**
 * Determine the exact last completed step. We need that to fill stepper status
 * and for further navigating user to the last non-completed step
 */
export const determineStepIndex = (formData: NonNullable<GetKyc['response']['data']>) => {
    return wizardSteps.reduce((acc, step, index) => {
        if (step === WizardStep.Submit) {
            return acc;
        }

        const isFilled = stepMeaningfulFieldsMap[step].every((meaningfulFields) => {
            const fields = typeof meaningfulFields === 'function' ? meaningfulFields(formData) : meaningfulFields;

            if (Array.isArray(fields)) {
                return fields.every((field) => isValueFilled(formData, field));
            }

            return isValueFilled(formData, fields);
        });

        return isFilled ? index : acc;
    }, -1);
};
